import { Module } from 'vuex';

import { RuleType, ValidationMode } from '@/shared/providers';
import { ILoginStore } from '../../../shared/store/shared.types';
import { IVerificationState } from './verification.types';

import actions from './verification.actions';
import mutations from './verification.mutations';
import getters from './verification.getters';

const verificationModule: Module<IVerificationState, ILoginStore> = {
  namespaced: true,
  state: {
    sykValue: '',
    networkError: undefined,
    sykFieldInfo: {
      type: 'text',
      label: '',
      icon: 'id',
      hint: '',
      validator: {
        name: '',
        mode: ValidationMode.AGGRESSIVE,
        rules: {
          [RuleType.REQUIRED]: true,
          [RuleType.MIN]: 4,
        },
      },
    },
  },
  mutations,
  getters,
  actions,
};

export default verificationModule;
